module.exports = __webpack_public_path__ + "img/nalo-hopkinson.d6d72e02.png";